import type { HtmlTagDescriptor } from 'vite'
import playgroundToolbarCss from './playgroundToolbarStyle.css?raw'
import playgroundToolbarScript from './playgroundToolbarScript.ts?compiled'

export function createPlaygroundToolbarTags(): HtmlTagDescriptor[] {
  const styleTag: HtmlTagDescriptor = {
    tag: 'style',
    attrs: { id: 'rundot-game-sandbox-style' },
    children: playgroundToolbarCss,
    injectTo: 'head',
  }

  const scriptTag: HtmlTagDescriptor = {
    tag: 'script',
    attrs: {
      type: 'module',
      id: 'rundot-game-sandbox-script',
      'data-rundot-game-ignore': 'true',
    },
    children: playgroundToolbarScript,
    injectTo: 'body',
  }

  return [styleTag, scriptTag]
}
